function initAllIngredientSections() {
  // Find all uninitialized ingredient wrappers on the page
  const wrappers = document.querySelectorAll('.piw-wrapper:not([data-initialized])');
  
  wrappers.forEach(wrapper => {
    // Mark as initialized so theme editor reloads don't double-fire events
    wrapper.setAttribute('data-initialized', 'true');
    
    // Extract the section ID dynamically from the wrapper's ID
    const sectionId = wrapper.id.replace('IngredientWidget-', '');
    
    // --- CAROUSEL LOGIC ---
    const track = wrapper.querySelector('.piw-carousel');
    const slides = wrapper.querySelectorAll('.piw-slide');
    const prevBtn = wrapper.querySelector('.piw-prev');
    const nextBtn = wrapper.querySelector('.piw-next');
    const pills = wrapper.querySelectorAll('.piw-pill');
    let currentIndex = 0;

    function updateActiveSlide(index) {
      index = parseInt(index);
      slides.forEach(s => s.classList.remove('is-active'));
      pills.forEach(p => p.classList.remove('is-active'));
      if(slides[index]) slides[index].classList.add('is-active');
      if(pills[index]) pills[index].classList.add('is-active');
      currentIndex = index;
    }

    function handleScroll() {
      if (!slides.length) return;
      const slideWidth = slides[0].offsetWidth;
      let newIndex = Math.round(track.scrollLeft / slideWidth);
      if (newIndex >= slides.length) newIndex = slides.length - 1;
      if (newIndex < 0) newIndex = 0;
      if (newIndex !== currentIndex) updateActiveSlide(newIndex);
    }

    let scrollTimeout;
    if(track) {
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScroll, 50); 
      });
    }

    if(prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        let targetIndex = currentIndex - 1;
        if (targetIndex < 0) targetIndex = slides.length - 1; 
        track.scrollTo({ left: slides[targetIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        let targetIndex = currentIndex + 1;
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (targetIndex >= slides.length || track.scrollLeft >= maxScroll - 10) targetIndex = 0; 
        track.scrollTo({ left: slides[targetIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        const index = e.target.getAttribute('data-index');
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    function toggleArrows() {
      if(!track) return;
      if(track.scrollWidth <= track.clientWidth) {
          if(prevBtn) prevBtn.style.display = 'none';
          if(nextBtn) nextBtn.style.display = 'none';
      } else {
          if(prevBtn) prevBtn.style.display = 'flex';
          if(nextBtn) nextBtn.style.display = 'flex';
      }
    }
    window.addEventListener('resize', toggleArrows);
    setTimeout(toggleArrows, 100); 
    updateActiveSlide(0);

    // --- DRAWER LOGIC ---
    const triggers = wrapper.querySelectorAll('[data-drawer-trigger]');
    const newOverlay = document.getElementById(`piw-overlay-${sectionId}`);
    const body = document.body;

    // 1. CLEANUP (Fixes Theme Editor "Ghost" Overlays)
    const oldOverlays = document.querySelectorAll(`.piw-drawer-overlay[data-section-id="${sectionId}"]`);
    oldOverlays.forEach(old => { if (old !== newOverlay) old.remove(); });
    
    const oldDrawers = document.querySelectorAll(`.piw-drawer[data-section-id="${sectionId}"]`);
    oldDrawers.forEach(old => { if (old.parentNode === body) old.remove(); });

    // 2. Move the new overlay and drawers to the body safely
    if (newOverlay) {
      newOverlay.setAttribute('data-section-id', sectionId);
      body.appendChild(newOverlay);
    }
    
    const drawers = document.querySelectorAll(`[id^="piw-drawer-${sectionId}-"]`);
    drawers.forEach(drawer => {
      drawer.setAttribute('data-section-id', sectionId);
      body.appendChild(drawer);
    });

    // 3. Open / Close Functions
    function openDrawer(index) {
      const drawer = document.getElementById(`piw-drawer-${sectionId}-${index}`);
      if(drawer) {
        drawer.classList.add('is-open');
        if(newOverlay) newOverlay.classList.add('is-active');
        body.style.overflow = 'hidden'; 
      }
    }

    function closeAllDrawers() {
      document.querySelectorAll('.piw-drawer.is-open').forEach(d => d.classList.remove('is-open'));
      document.querySelectorAll('.piw-drawer-overlay.is-active').forEach(o => o.classList.remove('is-active'));
      body.style.overflow = '';
    }

    // 4. Event Listeners
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (window.getSelection().toString().length > 0) return; 
        openDrawer(btn.getAttribute('data-drawer-trigger'));
      });
    });

    document.querySelectorAll('.piw-drawer-close').forEach(btn => btn.addEventListener('click', closeAllDrawers));
    
    if(newOverlay) {
      newOverlay.addEventListener('click', closeAllDrawers);
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initAllIngredientSections);

// Re-initialize if the section is added/edited in the Shopify Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  setTimeout(initAllIngredientSections, 50);
});